export default __webpack_public_path__ + "static/media/t2.4617c8e6.webp";